// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__D7Cd9","twitterFollow":"styles_twitterFollow__3_2gS","icon":"styles_icon__hsNua"};